import React from "react";
import { withRouter } from "react-router-dom";
import DropDown from "../../Dropdown/RealTimeButtonDropDown/DropDown"
import style from "./filters.module.scss";

const SnappShopFilters = (props) => {

    const defineFilterName = (filter) => {
        let name = ''
        switch (filter) {
            case 'errors':
                name = 'خطاها'
                break;
            case 'groupList':
                name = 'گروه کالا'
                break;
            case 'brandList':
                name = 'برند'
                break;
            default:
                name = 'فیلتر'
                break;
        }
        return name
    }

    return (
        <div className={style.wrapper}>
            {props.checkUrl() ? <div className={style.deleteAll} onClick={() => { props.handleDeleteAll() }}>
                <span className={style.icon}>g</span></div> : null
            }
            {Object.keys(props.filters).map((filters, filterIndex) => <div key={`filterIndex_${filterIndex}`}>
                <DropDown
                    tag={filters}
                    label={defineFilterName(filters)}
                    placeHolder={defineFilterName(filters)}
                    dropdownList={props.filters[filters]}
                    hasSearchBox={true}
                    hasCheckbox={true}
                    handleSearch={props.handleDropdownSearch}
                    deleteSelectedItems={() => props.deleteFromUrl(filters)}
                    handleSelect={props.handleChangeFilters}
                    action={flag => { }}
                />
            </div>)}
        </div>
    )
}

export default withRouter(SnappShopFilters);



